export { UserRewards } from './user-rewards.component';
